import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@one-thd/sui-atomic-components';
import { filterCatStyleCheckAndReturnUrl } from '../../product-results-helpers';

const AppliedRefinement = ({
  index,
  dimensionName,
  deselectUrl,
  label,
  onChange,
  refinementKey,
  onDisplay,
  desktopSort,
  hideDimensionName,
  apiDimensionName,
  apiRefinementName
}) => {

  const handleOnChange = () => {
    if (onChange) {
      let deselectUrlRevised = filterCatStyleCheckAndReturnUrl(deselectUrl);
      let querySeparator = '?';
      if (desktopSort.length > 0) {
        const [sortedBy, orderedBy] = desktopSort.split(':');
        if (deselectUrlRevised.includes('?')) {
          querySeparator = '&';
        }
        deselectUrlRevised += `${querySeparator}sortorder=${orderedBy}&sortby=${sortedBy}`;
      }

      onChange({
        refinement: {
          label,
          url: deselectUrlRevised,
          refinementKey,
          apiRefinementLabel: apiRefinementName
        },
        dimension: {
          label: dimensionName,
          apiDimensionLabel: apiDimensionName
        },
        onDisplay
      });
    }
  };

  return (
    <div className="sui-flex sui-flex-row">
      <Chip
        key={`applied-dimension-${index + refinementKey}`}
        title={hideDimensionName ? '' : dimensionName}
        label={label}
        onClick={handleOnChange}
        data-testid={`${hideDimensionName ? '' : dimensionName}: ${label}`}
      />
    </div>
  );
};

AppliedRefinement.propTypes = {
  index: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  dimensionName: PropTypes.string,
  deselectUrl: PropTypes.string,
  label: PropTypes.string,
  refinementKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onDisplay: PropTypes.string,
  desktopSort: PropTypes.string.isRequired,
  hideDimensionName: PropTypes.bool,
  apiDimensionName: PropTypes.string,
  apiRefinementName: PropTypes.string
};

AppliedRefinement.defaultProps = {
  index: null,
  dimensionName: null,
  deselectUrl: null,
  label: null,
  refinementKey: null,
  onDisplay: 'false',
  hideDimensionName: false,
  apiDimensionName: null,
  apiRefinementName: null
};

AppliedRefinement.displayName = 'AppliedRefinement';

export { AppliedRefinement };
